(function ($) {
  'use strict';

  /* ─── 1. Inject modal HTML once ─────────────────────────────────────── */
  const MODAL_ID   = 'vidalytics-popup-modal';
  const EMBED_ID   = 'vidalytics_embed_6NO9hygyDpXylrFk';
  const EMBED_URL  = 'https://fast.vidalytics.com/embeds/6BhWTSuq/6NO9hygyDpXylrFk/';

  const modalHTML = `
    <div id="${MODAL_ID}" role="dialog" aria-modal="true" aria-label="Video" style="
        display:none;
        position:fixed;inset:0;z-index:99999;
        background:rgba(0,0,0,.82);
        align-items:center;justify-content:center;">

      <!-- close button -->
      <button id="${MODAL_ID}-close" aria-label="Close video" style="
          position:absolute;top:16px;right:20px;
          background:transparent;border:none;cursor:pointer;
          color:#fff;font-size:32px;line-height:1;">&#x2715;</button>

      <!-- video wrapper -->
      <div style="width:min(880px,92vw);position:relative;">
        <div id="${EMBED_ID}" style="
            position:absolute;inset:0;
            width:100%;height:100%;"></div>
      </div>
    </div>`;

  $('body').append(modalHTML);

  const $modal = $('#' + MODAL_ID);

  /* ─── 2. Vidalytics loader ───────────────────────────────────────────── */
  let playerBooted = false;

  function bootVidalytics() {
    if (playerBooted) return;
    playerBooted = true;

    (function (v, i, d, a, l, y, t, c, s) {
      y = '_' + d.toLowerCase(); c = d + 'L';
      if (!v[d])  { v[d]  = {}; }
      if (!v[c])  { v[c]  = {}; }
      if (!v[y])  { v[y]  = {}; }

      var vl = 'Loader', vli = v[y][vl], vsl = v[c][vl + 'Script'],
          vlf = v[c][vl + 'Loaded'], ve = 'Embed';

      if (!vsl) {
        vsl = function (u, cb) {
          if (t) { cb(); return; }
          s = i.createElement('script');
          s.type = 'text/javascript'; s.async = 1; s.src = u;
          if (s.readyState) {
            s.onreadystatechange = function () {
              if (s.readyState === 'loaded' || s.readyState === 'complete') {
                s.onreadystatechange = null; vlf = 1; cb();
              }
            };
          } else {
            s.onload = function () { vlf = 1; cb(); };
          }
          i.getElementsByTagName('head')[0].appendChild(s);
        };
      }

      vsl(l + 'loader.min.js', function () {
        if (!vli) { var vlc = v[c][vl]; vli = new vlc(); }
        vli.loadScript(l + 'player.min.js', function () {
          var vec = v[d][ve]; t = new vec(); t.run(a);
        });
      });

    })(window, document, 'Vidalytics', EMBED_ID, EMBED_URL);
  }

  /* ─── 3. Open / close helpers ───────────────────────────────────────── */
  function openModal() {
    $modal.css('display', 'flex');
    $('body').css('overflow', 'hidden');   // prevent background scroll
    bootVidalytics();
  }

  function closeModal() {
    $modal.hide();
    $('body').css('overflow', '');

    // Remove & recreate the embed div so the video resets on next open
    $('#' + EMBED_ID).empty();
    playerBooted = false;
  }

  /* ─── 4. Event bindings ─────────────────────────────────────────────── */

  // Trigger: hero button
  $(document).on('click', '.hero-video--text-content .btn', function (e) {
    e.preventDefault();
    openModal();
  });

  // Close: × button
  $(document).on('click', '#' + MODAL_ID + '-close', closeModal);

  // Close: click outside video wrapper
  $(document).on('click', '#' + MODAL_ID, function (e) {
    if ($(e.target).is('#' + MODAL_ID)) closeModal();
  });

  // Close: Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $modal.is(':visible')) closeModal();
  });

})(jQuery);